// frontend/src/components/Tip.jsx
//
// 2026-10-22 (per Gilles — "make the tooltip box prettier") — a themed
// tooltip to replace the browser's grey default. Shows above the wrapped
// element on hover or keyboard focus; dark-surface card, soft shadow,
// readable line length. Touch devices get it on long-press focus.
import { useState } from 'react';

export default function Tip({ text, children, width = 240 }) {
  const [show, setShow] = useState(false);
  if (!text) return children;
  return (
    <span style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}
      onFocus={() => setShow(true)} onBlur={() => setShow(false)}>
      {children}
      {show && (
        <span role="tooltip" style={{
          position: 'absolute', bottom: 'calc(100% + 8px)', left: '50%', transform: 'translateX(-50%)',
          background: 'var(--surface-2)', color: 'var(--text)', border: '1px solid var(--border)',
          borderRadius: 10, padding: '8px 11px', fontSize: 12, fontWeight: 500, lineHeight: 1.5,
          width: `min(${width}px, 86vw)`, zIndex: 95, boxShadow: '0 8px 24px rgba(0,0,0,0.28)',
          textAlign: 'left', pointerEvents: 'none', whiteSpace: 'normal',
        }}>
          {text}
          <span style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)',
            border: '6px solid transparent', borderTopColor: 'var(--border)' }} />
        </span>
      )}
    </span>
  );
}
